/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum PaymentSummaryAliases {
  CARD_PAYMENT_SUMARY_CONTENT_0 = 'card-payment-sumary-content-0',
  CARD_PAYMENT_SUMMARY_HEADER_0 = 'card-payment-summary-header-0',
  CARD_PAYMENT_SUMMARY_LOCATION_0 = 'card-payment-summary-location-0',
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  FETCH_PAYMENT_SUMMARY = 'fetch-payment-summary',
  LAYOUT_0 = 'layout-0',
  LAYOUT_PAYMENT_SUMMARY = 'layout-payment-summary',
  MAPPER_0 = 'mapper-0',
  PANEL_0 = 'panel-0',
  PANEL_PAYMENT_SUMMARY = 'panel-payment-summary',
}
export { PaymentSummaryAliases };
